import React from 'react'
import './address.scss'
import img from '../undraw_My_location_re_r52x.png';
function Address() {
  const email = "info@test.de";
  const tel = "015114766666";
  const city = '41749 Viersen';
  const street = 'Spenglerstrasse 10';
  return (
    <div>
        <div className="address_container">
            <div className="address">
                <img src={img} alt="" />
                <h4>{street}</h4>
                <h4>{city}</h4>
            </div>
        </div>
    </div>
  )
}

export default Address